import { COMMON_NAMES, LOCATIONS, WEATHER_CONDITIONS, RIGS, ANTENNAS, RST_REPORTS, FAMOUS_HAMS } from '../data/qsoData';
import { generateCallSign } from '../utils';

export const generateQSO = (userCallsign = 'MYCALL', role = 'responder') => {
    let theirQTH, theirCall, theirName, theirRST, theirRig, theirAnt, theirWx;

    if (FAMOUS_HAMS && FAMOUS_HAMS.length > 0 && Math.random() < 0.10) {
        const famous = FAMOUS_HAMS[Math.floor(Math.random() * FAMOUS_HAMS.length)];
        theirCall = famous.call;
        theirName = famous.name;
        theirQTH = famous.qth;
        theirRig = famous.rig;
        theirAnt = famous.ant;
        theirRST = RST_REPORTS[Math.floor(Math.random() * RST_REPORTS.length)];
        theirWx = WEATHER_CONDITIONS[Math.floor(Math.random() * WEATHER_CONDITIONS.length)];
    } else {
        const location = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
        theirQTH = location.state ? `${location.city}, ${location.state}` : `${location.city}, ${location.country}`;
        theirCall = generateCallSign(location.region || location.country);
        theirName = COMMON_NAMES[Math.floor(Math.random() * COMMON_NAMES.length)];
        theirRST = RST_REPORTS[Math.floor(Math.random() * RST_REPORTS.length)];
        theirRig = RIGS[Math.floor(Math.random() * RIGS.length)];
        theirAnt = ANTENNAS[Math.floor(Math.random() * ANTENNAS.length)];
        theirWx = WEATHER_CONDITIONS[Math.floor(Math.random() * WEATHER_CONDITIONS.length)];
    }

    let script = [];

    if (role === 'responder') {
        // SCENARIO 1: They call CQ, You Answer
        script = [
            // 1. They call CQ
            {
                speaker: 'them',
                text: `CQ CQ CQ DE ${theirCall} ${theirCall} K`,
                hint: 'They are calling CQ. Get ready to answer.'
            },
            // 2. You answer
            {
                speaker: 'you',
                text: `DE ${userCallsign} K`,
                hint: 'Answer with your callsign.'
            },
            // 3. Their Exchange 1
            {
                speaker: 'them',
                text: `${userCallsign} DE ${theirCall} = GM UR RST ${theirRST} ${theirRST} = NAME ${theirName} ${theirName} = QTH ${theirQTH} = HW? ${userCallsign} DE ${theirCall} K`,
                hint: 'Copy their Report, Name, and QTH.'
            },
            // 4. Your Exchange 1
            {
                speaker: 'you',
                text: `${theirCall} DE ${userCallsign} = GM NAME OM = RST 599 599 = QTH HERE = ${theirName} DE ${userCallsign} K`,
                hint: 'Send your details.'
            },
            // 5. Their Exchange 2
            {
                speaker: 'them',
                text: `${userCallsign} DE ${theirCall} = R R FB = RIG IS ${theirRig} = ANT IS ${theirAnt} = WX IS ${theirWx} = TNX FOR QSO = 73 ${userCallsign} DE ${theirCall} SK`,
                hint: 'Copy their Rig, Antenna, and Weather info.'
            },
            // 6. Your Final
            {
                speaker: 'you',
                text: `73 TU ${theirCall} DE ${userCallsign} SK`,
                hint: 'Say goodbye.'
            }
        ];
    } else {
        // SCENARIO 2: You call CQ, They Answer (Initiator)
        script = [
            // 1. You call CQ
            {
                speaker: 'you',
                text: `CQ CQ CQ DE ${userCallsign} ${userCallsign} K`,
                hint: 'Call CQ to invite a contact.'
            },
            // 2. They answer
            {
                speaker: 'them',
                text: `${userCallsign} DE ${theirCall} K`,
                hint: 'Someone is answering you! Copy their callsign.'
            },
            // 3. Your Exchange 1
            {
                speaker: 'you',
                text: `${theirCall} DE ${userCallsign} = GM UR RST 599 599 = NAME OM = QTH HERE = HW? ${theirCall} DE ${userCallsign} K`,
                hint: 'Send your Report, Name, and QTH.'
            },
            // 4. Their Exchange 1
            {
                speaker: 'them',
                text: `${userCallsign} DE ${theirCall} = R GM OM = RST ${theirRST} ${theirRST} = NAME ${theirName} ${theirName} = QTH ${theirQTH} = ${userCallsign} DE ${theirCall} K`,
                hint: 'Copy their Report, Name, and QTH.'
            },
            // 5. Your Exchange 2
            {
                speaker: 'you',
                text: `${theirCall} DE ${userCallsign} = R FB = RIG IS MYRIG = ANT IS MYANT = WX IS SUNNY = 73 ${theirCall} DE ${userCallsign} SK`,
                hint: 'Send your Rig, Antenna, and Weather info.'
            },
            // 6. Their Final
            {
                speaker: 'them',
                text: `73 TU ${userCallsign} DE ${theirCall} SK`,
                hint: 'They are saying goodbye.'
            }
        ];
    }

    script.station = {
        callSign: theirCall,
        name: theirName,
        location: location
    };

    return script;
};
